import React, { useEffect, useState } from "react";

const DeleteAccount = ({ formData, setFormData }) => {
    const [passwordError, setPasswordError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        // Check password match when either password field changes
        if (name === "password" || name === "retypePassword") {
            const password = name === "password" ? value : formData.password;
            const retypePassword = name === "retypePassword" ? value : formData.retypePassword;
            
            if (password && retypePassword && password !== retypePassword) {
                setPasswordError("Passwords do not match");
            } else {
                setPasswordError("");
            }
        }
    };

    return (
        <>
            <div className="dc-tabscontent tab-content">
                <div className="dc-yourdetails dc-tabsinfo dc-delete-account">
                    <div className="dc-tabscontenttitle">
                        <h3>Delete Account</h3>
                    </div>
                    <div className="dc-formtheme dc-userform dc-sidepadding">
                        <fieldset>
                            <div className="form-group form-group-half">
                                <input 
                                    type="password" 
                                    name="password" 
                                    className="form-control" 
                                    placeholder="Enter Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group form-group-half">
                                <input 
                                    type="password" 
                                    name="retypePassword" 
                                    className="form-control" 
                                    placeholder="Retype Password"
                                    value={formData.retypePassword}
                                    onChange={handleChange}
                                />
                                {passwordError && (
                                    <div className="text-danger mt-1">{passwordError}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <span className="dc-select">
                                    <select 
                                        name="reason"
                                        value={formData.reason}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Reason to Leave</option>
                                        <option value="not_satisfied">No satisfied with the system</option>
                                        <option value="support">Support is not good</option>
                                        <option value="other">Others</option>
                                    </select>
                                </span>
                            </div>
                            <div className="form-group">
                                <textarea 
                                    name="description" 
                                    className="form-control" 
                                    placeholder="Description (Optional)"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeleteAccount;
